import { injectIntl } from 'react-intl';
import messages from './messages';
import plants from '../../assets/plants/plants.json';
import TypeMultiply from '../AnswerTypeMultiply';

class TypePlants extends TypeMultiply{
	getData() {
		return plants.map( p => this.props.intl.formatMessage(messages[p.id]));
	}
}

export default injectIntl(TypePlants);



// WEBPACK FOOTER //
// ./src/components/AnswerTypePlants/TypePlants.js